import axios from 'axios'
import { isCertDomain } from '../constants/const'

/**
 * cert 環境で、API から応答が無かった（TLS 層で拒否された）エラーか。
 *
 * ブラウザが証明書を送らない・失効・非信頼のとき、ALB は TLS の段階で接続を
 * 切るので、axios の error に response が無い。応答がある（302・403・5xx 等）
 * なら TLS は通っている = 証明書は送れている。オフライン中の無応答は証明書の
 * 問題ではないので除く。
 *
 * ログイン画面（マウント時の疎通・ログインの失敗）とメンテナンスの判定が
 * 同じ分類をしないと、同じ無応答が画面ごとに別物になる。判定はここに 1 つ置く。
 */
export const isCertTlsRejection = (error: unknown): boolean =>
  isCertDomain &&
  axios.isAxiosError(error) &&
  !error.response &&
  navigator.onLine
